import styled from "styled-components";
import variables from "../../assets/js/variables";
import { hexToRgbA } from "../../utilities/converters";

const { colors } = variables;

const positionPoints = {
  2: {
    //center right
    left: "calc(50% + 28.5714vw)",
    top: "calc(50% - 2.5vw)",
  },
  4: {
    //top left
    left: "calc(48% - 23.8095vw)",
    top: "calc(50% - 11.1111vw)",
  },
  1: {
    //top right
    left: "calc(51% + 18.1818vw)",
    top: "calc(50% - 14.2857vw)",
  },
  3: {
    //bottom right
    left: "calc(50% + 27.027vw)",
    top: "calc(50% + 10vw)",
  },
  6: {
    //center left
    left: "calc(45% - 27.3973vw)",
    top: "50%",
  },
  5: {
    //bottom left
    left: " calc(45% - 12.5vw)",
    top: "calc(50% + 12.5vw)",
  },
};

const positionPointsMobile = {
  2: {
    //center right
    left: "calc(50% + (100vw / 2.5))",
    top: "calc(50% - (100vw / 60))",
  },
  4: {
    //top left
    left: "calc(50% - (100vw / 3));",
    top: "calc(50% - (100vw / 3.5))",
  },
  1: {
    //top right
    left: "calc(51% + (100vw / 3.2));",
    top: "calc(50% - (100vw / 5))",
  },
  3: {
    //bottom right
    left: "calc(50% + (100vw / 4.5))",
    top: "calc(50% + (100vw / 3.7))",
  },
  6: {
    //center left
    left: "calc(50% - 45.4545vw)",
    top: " calc(50% - 2.04082vw)",
  },
  5: {
    //bottom left
    left: "calc(50% - (100vw / 4))",
    top: "calc(50% + (100vw / 6))",
  },
};

const StyledBrainButtons = styled.div`
  width: 43vw;
  height: 33vw;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, calc(-50% - 50px));
  border-radius: 50%;
  direction: ltr !important;

  .information_button__description {
    direction: rtl;
    max-width: 100%;
    text-align: justify;
  }

  .information_button__close {
    float: left;

    span {
      font-size: 24px;
      color: ${colors.whiteSmoke};
    }
  }

  .absolute-button {
    position: absolute;
    background: transparent;
    width: 0;
    height: 0;
    outline: unset;
    box-shadow: unset;
    border: unset;
    transition: 300ms;
    display: inline-block;
    padding: 0;
    direction: ltr !important;
    z-index: 1;

    ${Object.keys(positionPoints).map(
      (item) =>
        `&:nth-child(${item}){
        left: ${positionPoints[item].left};
        top: ${positionPoints[item].top};
      }`
    )};

    @media (max-width: 768px) {
      background: ${colors.green};
      width: 15px;
      height: 15px;
      border-radius: 50%;

      ${Object.keys(positionPointsMobile).map(
        (item) =>
          `&:nth-child(${item}){
          left: ${positionPointsMobile[item].left};
          top: ${positionPointsMobile[item].top};
        }`
      )};
    }
  }

  @media (max-width: 768px) {
    .absolute-button {
      &:focus-within {
        background: ${colors.text};

        &.is-show_for__mobile {
          z-index: 9;
        }

        &:after {
          border: 1px solid ${colors.text};
          width: 40px;
          height: 40px;
        }

        .absolute-button_info {
          width: 300px;
          height: max-content;
          left: 50px;
          top: 50px;
          border-radius: 30px;
          padding: 32px;
          border-color: ${colors.blue};
          z-index: 9;

          &:before {
            top: -20px;
            left: -6px;
            width: 2px;
            height: 34px;
            transform: rotate(-45deg);
            background: ${colors.text};
          }
        }
      }
    }
  }
  @media (min-width: 769px) {
    .absolute-button:focus-within .absolute-button_info:before {
      background: ${colors.text};
    }
  }

  .brain-button_show_info {
    width: 30vw;
    height: max-content;
    left: 50%;
    top: 50%;
    border-radius: 10px;
    padding: 32px;
    border: 1px solid ${colors.blue};
    background: ${hexToRgbA(colors.background, 0.95)};
    transform: translate(-50%, -50%);
    color: ${colors.whiteSmoke};
    font-size: 14px;
    position: absolute;
    z-index: 99;
  }

  @media (max-width: 768px) {
    width: 83vw;
    height: 57vw;
    top: 55vh;
  }
  .nth:nth-child(odd) {
    .absolute-button {
      .absolute-button_info {
        &:before {
          right: 100%;
        }
      }
    }
  }
  .nth:nth-child(even) {
    .absolute-button {
      .absolute-button_info {
        right: 0;

        &:before {
          left: 100%;
        }
      }
    }
  }
  .absolute-button:nth-child(5) {
    .absolute-button_info {
      right: 0;
      &:before {
        left: 108%;
      }
    }
  }
  .absolute-button:nth-child(4) {
    .absolute-button_info {
      right: 0;
      &:before {
        left: 108%;
      }
    }
  }
  .absolute-button:nth-child(6) {
    .absolute-button_info {
      right: 0;
      &:before {
        left: 108%;
      }
    }
  }
`;

export default StyledBrainButtons;

export const StyledButton = styled.button`
  .absolute-button_info {
    position: absolute;
    border: 1px solid transparent;
    transition: 300ms;
    background: ${hexToRgbA(colors.background, 0.7)};
    color: ${colors.text};
    z-index: 9;
    border-radius: 50%;
    font-size: 24px;
    ${({ coordinates }) => coordinates.root};
    top: 50%;
    bottom: 50%;
    transform: translateY(-48%);

    &:before {
      content: "";
      position: absolute;
      z-index: 0;
      transition: 200ms;
      background: ${colors.green};
      height: 1px;
      width: 56px;
      top: 47%;

      ${({ coordinates }) => coordinates.before};
    }

    > * {
      color: ${colors.text};
    }
  }

  @media (max-width: 768px) {
    .absolute-button_info {
      width: 0;
      height: 0;
      padding: 0;
      overflow: hidden;
      border-color: transparent;
      top: 0;
      left: 0;
      right: 0;
      transform: unset;
      font-size: 12px;

      &:before {
        top: 0;
        left: 0;
        width: 2px;
        height: 32px;
        transform: unset;
      }
    }

    &.is-show_for__mobile {
      left: calc(50% - 10px) !important;
      top: 0 !important;
      transform: translateY(-10vh);
      z-index: 9;

      .absolute-button_info {
        width: 0;
        height: 0;
        padding: 0;
        border-color: transparent;
        top: 0;
        left: 0;
        right: 0;
        transform: unset;
      }

      &.absolute-button {
        &:focus-within {
          .absolute-button_info {
            width: 90vw;
            max-height: 50vh;
            left: 50%;
            top: 76px;
            z-index: 9;
            transform: translateX(-50%);
            overflow-y: scroll;
            padding: 25px;

            &:before {
              top: -34px;
              left: calc(45vw - 1px);
              transform: unset;
            }
          }
        }
      }
    }
  }

  .button-information-data-enter-done {
    opacity: 1;
  }

  .button-information-data-enter {
    opacity: 0;
    transition: opacity 300ms;
  }

  .button-information-data-enter-active {
    opacity: 1;
  }

  .button-information-data-exit {
    display: none;
    opacity: 0;
  }
`;
